export class Quotes {
  #container;
  #activeQuoteId;

  constructor(element) {
    this.#container = element;

    if (!this.#container.classList.contains('quotes')) this.#container = this.#container.closest('.quotes');

    if (!this.#container || !this.#container.classList.contains('quotes')) return;

    const quotes = this.#container.querySelectorAll('.quote');
    if (quotes.length === 0) return;

    this.#bindEvents(quotes);
  }

  #gotoQuote(el) {
    this.#activeQuoteId = el.dataset.gotoQuoteId;

    this.#container.querySelectorAll('.quote').forEach(quoteEl => {
      if (quoteEl.dataset.quoteId === this.#activeQuoteId)
        quoteEl.classList.add('quote--active');
      else {
        if (quoteEl.classList.contains('quote--active')) quoteEl.classList.add('quote--off');
        quoteEl.classList.remove('quote--active');
      }
    });
    this.#container.querySelectorAll('.quote-controls__control').forEach(controlEl => {
      if (controlEl.dataset.gotoQuoteId === this.#activeQuoteId)
        controlEl.classList.add('quote-controls__control--active');
      else
        controlEl.classList.remove('quote-controls__control--active');
    });

    setTimeout(() => {
      this.#container.querySelectorAll('.quote').forEach(quoteEl => {
        quoteEl.classList.remove('quote--off');
      });
    }, 500);
  }

  #handleSwipe(xDiff) {
    const minSwipeDistance = 50; // The minimum horizontal distance in pixels to be considered a swipe
    if (Math.abs(xDiff) <= minSwipeDistance) return;

    const quoteControls = [...this.#container.querySelectorAll('.quote-controls__control')];
    if (quoteControls.length === 0) return;

    if (!this.#activeQuoteId) this.#activeQuoteId = quoteControls[0].dataset.gotoQuoteId;

    const activeIndex = quoteControls.findIndex(controlEl => controlEl.dataset.gotoQuoteId === this.#activeQuoteId);
    if (activeIndex === -1) return;

    // Swipe left goes to the next quote, swipe right to the previous one, wrapping around at the edges.
    const newIndex = xDiff > 0 ?
      (activeIndex + 1) % quoteControls.length :
      (activeIndex - 1 + quoteControls.length) % quoteControls.length;

    this.#gotoQuote(quoteControls[newIndex]);
  }

  #bindEvents(quotes) {
    this.#container.querySelectorAll('[data-goto-quote-id]').forEach(el => {
      el.addEventListener('click', () => this.#gotoQuote(el));
    });

    quotes.forEach(el => {
      let touchstartX = 0;
      let touchendX = 0;

      el.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX;
      });

      el.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX;
        this.#handleSwipe(touchstartX - touchendX);
      });
    });
  }
}
